import styled from "styled-components";

import { colourScheme } from "utils/styling/colours";

export const ModalContainer = styled.div`
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
    background-color: ${colourScheme.primaryLight};
    text-align: center;
    align-items: center;
    border-radius: 0.5rem;
    max-width: 26rem;
    & > hr {
        width: 100%;
        color: ${colourScheme.white};
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: center;
`;

export const GoldCost = styled.span`
    color: gold;
    font-size: 0.9em;
    margin-left: 0.5rem;
`;
